export class UserRoles {
  static SB = 'sb'
  static TRUSTED_USER = 'trusted_user'
  static PNT = 'pnt'
  static SUBDIVISION = 'subdivision'
  static SUPERVISOR = 'supervisor'
  static USER = 'user'
  static SB_TRUCK = 'sb_truck'
  static SB_OTHER = 'sb_other'
  static AGENT = 'agent'
  static AGENT_PRIME = 'agent_prime'
  static SB_SUBDIVISION = 'sb_subdivision'
  static SB_BLACKLIST = 'sb_blacklist'
  static ACCOUNTING = 'accounting'
  static MANAGEMENT_BUILDING = 'management_building'
}
